import angular from 'angular';

angular.module('AaApp.Opp').constant('vehicleActions', {
    doesNotOwnVehicle: 1,
    vehiclePaidOff: 2,
    vehicleNotPaidOff: 3,
    purchasedByDealer: 4
});
